import { Wrapper, Label, Subtitle } from "./GradingCard.styles";

function GradingCard(props: { title: string; subtitle: string }) {
  const { title, subtitle } = props;
  return (
    <Wrapper>
      <Label>{title}</Label>
      <Subtitle>{subtitle}</Subtitle>
    </Wrapper>
  );
}

export default GradingCard;
